import React, { useContext } from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { AppContext } from 'contexts';
import 'styles/animations.scss';

const useStyles = makeStyles({
  qrCodeBoxContainer: {
    position: 'absolute',
    display: 'none',
    top: 61,
    right: 0,
    backgroundColor: 'white',
    padding: 30,
    animation: 'slide-down .2s ease-in',

    '&.open': {
      display: 'block',

      '@media (max-width: 767px)': {
        display: 'none',
      },
    },
  },
  closeButton: {
    position: 'absolute',
    top: 15,
    right: 15,
    cursor: 'pointer',
  },
  qrCodeBox: {
    display: 'flex',
    alignItems: 'center',
  },
  qrCodeImage: {
    width: 200,
    height: 200,
  },
  openAppLinkContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    textDecoration: 'underline',
  },
  instructionsBox: {
    display: 'flex',
    alignItems: 'flex-start',
    maxWidth: '200px',
    margin: 0,
  },
  instructionsText: {
    fontSize: 18,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  mobileMenu: {
    position: 'absolute',
    display: 'none',
    top: 61,
    right: 0,
    backgroundColor: 'white',
    padding: 30,
    animation: 'slide-down .2s ease-in',

    '&.open': {
      display: 'block',
    },

    '@media (max-width: 767px)': {
      top: 101,
    },
  },
});

function QRCode() {
  const classes = useStyles();
  const appContext = useContext(AppContext);

  const { listing, getQRCodeDisplay, setQRCodeDisplay } = appContext;

  const qrCodeDisplay = getQRCodeDisplay();

  const qrCodeUrl =
    listing && listing.qr_code && listing.qr_code.qr_code
      ? listing.qr_code.imageURL
      : null;

  const openAppLink =
    listing && listing.qr_code
      ? `https://redirect.hausvalet.ca/qr_code.html?code=${listing.qr_code.qr_code}`
      : '';

  const instructions =
    "Utilisez l'application Hausvalet VR pour accéder à cette propriété en réalité virtuelle.";

  const openAppInstructions = 'Ouvrir Hausvalet VR';

  const onClose = () => {
    setQRCodeDisplay(false);
  };

  const linkClick = () => {
    if (openAppLink !== '') {
      window.open(openAppLink);
    }
  };

  const renderMobileQRCode = () => {
    return (
      <div className={classNames(classes.mobileMenu, { open: qrCodeDisplay })}>
        <div
          className={classes.openAppLinkContainer}
          onClick={linkClick}
          onTouchEnd={linkClick}
        >
          {openAppInstructions}
        </div>
      </div>
    );
  };

  const renderDesktopQRCode = () => {
    return (
      <div className={classNames(classes.qrCodeBoxContainer, { open: qrCodeDisplay })}>
        <div className={classes.closeButton}>
          <img
            src='/images/xIcon.png'
            alt='Fermer'
            onClick={onClose}
            onTouchEnd={onClose}
          />
        </div>
        <div className={classes.instructionsBox}>
          <div className={classes.instructionsText}>{instructions}</div>
        </div>
        <div className={classes.qrCodeBox}>
          <img
            className={classes.qrCodeImage}
            src={qrCodeUrl}
            alt='Code QR Réalité virtuelle'
          />
        </div>
        <div className={classes.openAppLinkContainer}>
          <a href={openAppLink}>{openAppInstructions}</a>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderMobileQRCode()}
      {renderDesktopQRCode()}
    </>
  );
}

export default QRCode;
